<template>
  <div>
     <el-dialog title="图层列表" :visible.sync="dialogVisible" width="30%" :before-close="close" append-to-body :close-on-click-modal="false">
        <div style="display: flex;justify-content: space-between;margin: 10px 0;">
            <el-input v-model="filterKeyWord" size="small" suffix-icon="el-icon-search" placeholder="请输入关键字" clearable spellcheck="false" />
        </div>
        <div class="tree-container">
          <el-tree
            draggable
            ref="tree"
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            @check-change="handleCheckChange"
            @node-drag-end="handleNodeDragEnd"
            :filter-node-method="handleFilterNode">
              <template #default="{ node }">
                <span class="custom-tree-node">
                  <span>{{ node.label }}</span>
                </span>
              </template>
          </el-tree>
        </div>     
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="handleConfirm">
                    确定
                </el-button>
            </span>
        </template>
    </el-dialog>
 
  </div>
</template>

<script>
import {  getTree, postTree, delTree,putTree } from "@/api/layer.js"
import PinyinMatch from "pinyin-match"
export default {
  name: 'ConfigLayerDialog',
  props:{
    openReset:{
        type:Boolean,
        default:()=>true
    }
  },
  data() {
    return {
        defaultProps: {
            children: 'children',
            label: 'name',
        },
        treeData:[],
        isBatchAdd:false,
        dialogVisible:false,
        editorDialogVisible:false,
        parentNode:null,

        filterKeyWord:'',
        form:{},
        copyNodeData:null,
    };
  },
  watch:{
    filterKeyWord(){
        const tree = this.$refs.tree
        if(tree){
            tree.filter(this.filterKeyWord)
        }
    },
    dialogVisible(){
        if(this.dialogVisible){
            this.getList()
        }
    },
  },

  mounted() {
    this.getList()
  },

  methods: {
    handleBatchAdd(node,data){
        this.isBatchAdd = true
        this.parentNode = node || null 
        this.resetForm()
        
    },
    handleEditorRow(node,data){
        this.isBatchAdd = false
        this.editorDialogVisible = true
        this.resetForm(data)
    },
    handleCopyRow(node,data){
        this.copyNodeData = data
        this.$message({
            message: '已复制',
            type: 'success',
        })
    },
    handlePaseRow(node,data){
        this.copyNodeData.parentId = data.id
        this.copyNodeData.id = ''
        postTree(this.copyNodeData).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                    message: '粘贴成功',
                    type: 'success',
                })
            } else {
              this.$message.error('粘贴失败')

            }
        })
    },
    handleDeleteRow(node,data){
        const { id } = data
        this.$confirm('是否删除此图层？','提示', {confirmButtonText: '是',cancelButtonText: '否', type: 'warning',})
        .then(() => {
            delTree(id).then((res) => {
                if (res.data.code == 200) {
                  this.$message({
                        message: '删除成功！',
                        type: 'success',
                    })
                } else {
                  this.$message({
                        message: '删除失败！',
                        type: 'error',
                    })
                }
            })
        })
        .catch(() => {
        })
    },
    handleAddNewRow(node,data) {
        this.isBatchAdd = false
        this.parentNode = node || null  
        this.resetForm()
        this.editorDialogVisible = true
    },
    handleEndEdit(){
        
        const isEditor = this.form.id && this.form.id !==''
        if (isEditor) {
            //保存编辑
            putTree(form).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                    message: '编辑成功！',
                    type: 'success',
                })
                this.closeEditorDialog()
            } else {
              this.$message({
                    message: '编辑失败！',
                    type: 'error',
                })
                this.closeEditorDialog()
            }
        })
        }else if(this.isBatchAdd){
            //批量新增
        }else{
            //新增
            postTree(form).then((res) => {
                if (res.data.code == 200) {
                  this.$message({
                        message: '添加成功！',
                        type: 'success',
                    })
                    this.closeEditorDialog()
                } else {
                  this.$message({
                        message: '添加失败！',
                        type: 'error',
                    })
                    this.closeEditorDialog()
                }
            })
        }
    },
    handleFilterNode(value, data){
      //过滤节点
      if (!value) return true;
      return PinyinMatch.match(data.name,value)
    },
    handleCheckChange(){

    },
    handleNodeDragEnd(node, enterNode, position, event){
        console.log('handleNodeDragEnd',node, enterNode, position, event);
    },
    handleConfirm(){
        this.close()
        const checkKeys = this.$refs.tree.getCheckedKeys()
        
        const allDatas = JSON.parse(JSON.stringify(this.treeData))
        const filterDatas = this.filterTreeData(checkKeys,JSON.parse(JSON.stringify(allDatas)))
        this.$emit('select-change', filterDatas);
    },
    resetForm(form_data){
        const form = form_data || {
            id:'',
            parentId: this.parentNode?.data?.id || 0,
            name: '',
            url: '',
            latitude: '',
            longitude: '',
            layer: '',
            photoType: '',
            height: '',
            translate:'',
            tileMatrixSetID:'',
            dataInfo: '',
            imgPosition:'',
            imgUrl:'',
            keyword:'',
            sortNo:'',
        }
        this.form=form
    },
    openEditorDialog(){
        this.editorDialogVisible = true
    },
    closeEditorDialog(){
        this.editorDialogVisible = false
    },
    open(){
        this.dialogVisible=true
        if (this.openReset) {
            this.$nextTick(()=>{
                const tree= this.$refs.tree
                tree && tree.setCheckedKeys([])
            })
            
        }
    },
    close(){
        this.dialogVisible=false
    },
    getList(){
        getTree().then(res=>{
            if (res.data.code == 200) {
            this.treeData = res.data.data
        } else {
            console.log('获取树状图失败！');
        }
        })
    },
    //获取节点方法
    filterTreeData(ids, datas) {
        var filteredNodes = [];
        for (var i = 0; i < datas.length; i++) {
            var data = datas[i];
            if (ids.includes(data.id)) {
                filteredNodes.push(data);
                continue
            }
            if (data.children && data.children.length > 0) {
                data.children = this.filterTreeData(ids, data.children); 
                if (data.children.length>0) {
                    filteredNodes.push(data);
                }
            }
        }
        return filteredNodes;
    }
  },
};
</script>

<style scoped>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
.tree-container{
  max-height:400px;
  overflow-y:auto
}

</style>